import { useState } from "react";
import {
  SelectPlanContainer,
  SelectPlanHeader,
  PlanCardsContainer,
  HeaderSpan,
  NoCardRequiredDiv,
  NoCardRequiredText,
} from "./selectPlanStyles";
import {
  CommonText,
  CommonImage,
} from "../../../../../styledComponents/common";

import SinglePlanCard from "./SinglePlanCard";

import greenTick from "../../../../../assets/img/icons/tick-green.svg";

export default function SelectPlan({
  eliteYearly,
  standardYearly,
  handleSubmitData,
  onboardingIsLoading,
}) {
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handlePlanSelect = (plan) => {
    if(onboardingIsLoading){
      return;
    }
    
    setSelectedPlan(plan);

    handleSubmitData(plan?.id);
  };

  return (
    <SelectPlanContainer>
      <SelectPlanHeader>
        <CommonText
          fontSize="24px"
          smallLaptopFontSize="20px"
          tabFontSize="18px"
          mobileFontSize="16px"
          fontWeight="600"
          name
        >
          How Do You Want to Manage Your Operations?
        </CommonText>
        <NoCardRequiredDiv>
          <CommonImage src={greenTick} alt="" size="20px" />
          <NoCardRequiredText>No credit card required</NoCardRequiredText>
        </NoCardRequiredDiv>
      </SelectPlanHeader>
      <PlanCardsContainer>
        <SinglePlanCard
          title="Site Management"
          name="standard"
          plan={standardYearly}
          handlePlanSelect={handlePlanSelect}
          isLoading={
            selectedPlan?.id === standardYearly?.id && onboardingIsLoading
          }
        />
        <SinglePlanCard
          title="Job Management"
          name="elite"
          plan={eliteYearly}
          handlePlanSelect={handlePlanSelect}
          isLoading={
            selectedPlan?.id === eliteYearly?.id && onboardingIsLoading
          }
        />
      </PlanCardsContainer>
    </SelectPlanContainer>
  );
}
